import BpkHorizontalNav, {
  BpkHorizontalNavItem,
} from '@skyscanner/backpack-web/bpk-component-horizontal-nav';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import MainPrice from './MainPrice';

import type { I18nService } from '@shared/types/i18n';
import type { Nullable, Stay } from '@shared/types/utils';
import type { NavigationItems } from '@shared/utils-frontend/navigation-service';

import STYLES from './PrimaryNavigation.module.scss';

import { withI18n } from '@shared/ui/contexts/i18n';

const cls = cssModules(STYLES);

type Props = {
  i18n: I18nService;
  items: NavigationItems;
  onClick: (anchorName: string, id: string) => void;
  needFixed: boolean;
  selected?: Nullable<string>;
  stay: Stay;
  priceIndex: number;
};

const PrimaryNavigation = ({
  i18n,
  items,
  needFixed,
  onClick,
  priceIndex = 0,
  selected = null,
  stay,
}: Props) => (
  <div className={cls('PrimaryNavigation')}>
    <BpkHorizontalNav
      ariaLabel={i18n.translate('ktxtNavigationTabs')}
      className={
        needFixed
          ? cls('PrimaryNavigation__shadow')
          : cls('PrimaryNavigation__navigation')
      }
    >
      {items
        .filter((item) => item.isShow)
        .map(({ anchorName, id, text }) => (
          <BpkHorizontalNavItem
            key={id}
            className={cls('PrimaryNavigation__bar')}
            data-test-id={`${id}-navigation`}
            selected={selected === id}
            onClick={(e: Event) => {
              e.preventDefault();
              onClick(anchorName, id);
            }}
            href={`#${anchorName}`}
          >
            <BpkText
              textStyle={TEXT_STYLES.label2}
              tagName="p"
              className={cls('PrimaryNavigation__barText')}
            >
              {i18n.translate(text)}
            </BpkText>
          </BpkHorizontalNavItem>
        ))}
    </BpkHorizontalNav>
    <MainPrice stay={stay} priceIndex={priceIndex} />
  </div>
);

export default withI18n(PrimaryNavigation);
